<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  
  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Header-->
    <!-- <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Coverage Encoding List</span>
      </h3>
    </div> -->
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <br/>
       
        <br/>
        <div class="row">
                      <!--begin::Input group-->
            <div class="mb-10">
              <!--begin::Title-->
              <h4 class="fs-5 fw-bold text-gray-800">
                Share my referral link with friends
              </h4>
              <!--end::Title-->

              <!--begin::Title-->
              <div class="d-flex">
                <input
                  ref="inputRef"
                  id="ovi_survey_form_link"
                  type="text"
                  class="form-control form-control-solid me-3 flex-grow-1"
                  name="search"
                  v-model="shareLink"
                />

                <button
                  ref="copyButtonRef"
                  id="kt_share_earn_link_copy_button"
                  class="btn btn-light fw-bolder flex-shrink-0"
                  data-clipboard-target="#ovi_survey_form_link"
                >
                  Copy Link
                </button>
                &nbsp;&nbsp;
                <button
                class="btn btn-light fw-bolder flex-shrink-0"
                  v-on:click="isShowShareDiv()"
                  v-if="!this.showShareDiv"
                >
                  Share Now
                </button>
                <button
                class="btn btn-light fw-bolder flex-shrink-0"
                  v-on:click="isShowShareDiv()"
                  v-if="this.showShareDiv"
                >
                  Cancel Share
                </button>
              </div>
              <!--end::Title-->
            </div>
            <!--end::Input group-->


            <div id="share-network-list" v-if="this.showShareDiv">
              
              <div class="border border-gray-300 border-dashed rounded py-3 px-4 me-6 mb-3" style="width:900px !important;">
               <div class="row" align="center">
                  <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;Share Details</div>
               </div>
               <div class="row">
                <div class="col-lg-12">
                  <div class="row mt-5">
                    <div class="col-lg-2 mb-3">
                      <label class="col-form-label  fw-bold fs-6" >Title:</label>
                    </div>
                    <div class="col-lg-10 mb-3">
                      <textarea rows="4"  type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="Title" name="share_title" v-model="sharing.title"></textarea>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-2 mb-3">
                      <label class="col-form-label  fw-bold fs-6" >Description:</label>
                    </div>
                    <div class="col-lg-10 mb-3">
                      <textarea rows="4"  type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="Description" name="share_desc" v-model="sharing.description"></textarea>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-2 mb-3">
                      <label class="col-form-label  fw-bold fs-6" >Quote:</label>
                    </div>
                    <div class="col-lg-10 mb-3">
                      <textarea rows="4"  type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="Quote" name="share_quote" v-model="sharing.quote"></textarea>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-2 mb-3">
                      <label class="col-form-label  fw-bold fs-6" >Hashtags:</label>
                    </div>
                    <div class="col-lg-10 mb-3">
                      <textarea rows="4" type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="Hashtags" name="share_hashtags" v-model="sharing.hashtags"></textarea>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-2 mb-3">
                      <label class="col-form-label  fw-bold fs-6" >Share With:</label>
                    </div>
                    <div class="col-lg-6 mb-3">
                      <select class="form-select form-select-solid form-select-lg fw-bold mb-2" name="share_socmed" v-model="share_socmed">
                        <option value="">Select One</option>
                        <template v-for="network in networks" v-bind:key="network.network">
                          <option v-bind:value="network.network" >{{network.network.toUpperCase()}}</option>
                        </template>
                      </select>
                    </div>
                    <div class="col-lg-4 mb-3">
                        <template v-for="network in networks">
                          <ShareNetwork
                          v-if="network.network.toUpperCase() == share_socmed.toUpperCase()"
                          :network="network.network"
                          :key="network.network"
                          :style="{backgroundColor: network.color}"
                          :url="shareLink"
                          :title="sharing.title"
                          :description="sharing.description"
                          :quote="sharing.quote"
                          :hashtags="sharing.hashtags"
                          :twitterUser="sharing.twitterUser"
                          class="form-control"
                        >
                          <i :class="network.icon"></i>
                          <span>Share with{{ network.name }}</span>
                        </ShareNetwork>
                        </template>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>



            

          
        </div>
        
        <br/>
      <!--begin::Table container-->
      <div class="table-responsive" v-if="!this.showShareDiv">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">#</th>
              <th class="min-w-225px">Name</th>
              <th class="min-w-200px">Importance Of Accident Protection</th>
              <th class="min-w-200px">Budget For Protection</th>
              <th class="min-w-200px">Number Of People To Cover</th>
              <th class="min-w-200px">Stays In The Philippines</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{index + 1}}</td>
                <td>
                  <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">{{item.nickname}}</a>
                  <span class="text-muted fw-bold d-block mb-1">{{item.email}}</span>
                  <span class="text-muted fw-bold d-block mb-1">{{item.cpnumber}}</span>
                </td>
                <td>
                  <!-- <div class="d-flex align-items-center w-200px w-sm-300px flex-column mt-3">
                    <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                      <span class="fw-bolder fs-6">{{(item.howimportant / 10) * 100}}     %</span>
                    </div>
                    <div class="h-5px mx-3 w-100 bg-light mb-3">
                      <div class="bg-success rounded h-5px" role="progressbar" aria-valuenow="5" aria-valuemin="0" aria-valuemax="10" 
                        :style="{'width':`${parseInt(100 * (item.howimportant / 10 ))}%` }"></div>
                    </div>
                  </div> -->
                    <div class="rating">
                      <div class="rating-label me-2" :class="item.howimportant > 0 ? 'checked' : ''">
                        <i class="bi bi-star-fill fs-5"></i>
                      </div>
                      <div class="rating-label me-2" :class="item.howimportant > 1 ? 'checked' : ''">
                        <i class="bi bi-star-fill fs-5"></i>
                      </div>
                      <div class="rating-label me-2" :class="item.howimportant > 2 ? 'checked' : ''">
                        <i class="bi bi-star-fill fs-5"></i>
                      </div>
                      <div class="rating-label me-2" :class="item.howimportant > 3 ? 'checked' : ''">
                        <i class="bi bi-star-fill fs-5"></i>
                      </div>
                      <div class="rating-label me-2" :class="item.howimportant > 4 ? 'checked' : ''">
                        <i class="bi bi-star-fill fs-5"></i>
                      </div>
                    </div>





                </td>
                <td>{{item.allocated_budget}}</td>
                <td>{{item.coverage_people}}</td>
                <td>{{item.stayphil.toUpperCase()}}</td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
  </div>
  <!--end::Tables Widget 11-->
 
</template>

<script lang="ts"> 
import { defineComponent,ref,onMounted } from "vue";
import {loadSurveyResultsList}  from "@/api/myprospects";
import ClipboardJS from "clipboard";

export default defineComponent({
  name: "myprospects", 
  methods: {
    async loadSurveyResultsList(){ 
      this.loading = true;
      const response = await loadSurveyResultsList();
       this.list = response.data.pageList; 
       this.cifid = response.data.cifid;
       this.shareLink = "https://survey.orbixvictusinternational.com/?cifid=" + this.cifid;
       this.loading = false;
    }, 
    async isShowShareDiv(){
      this.showShareDiv = !this.showShareDiv;
      console.log(this.showShareDiv);
    },
    async test(){
      console.log(this.share_socmed);
    }
  },
  mounted(){
      this.loadSurveyResultsList(); 
  },
  setup() {
    const copyButtonRef = ref<null | HTMLElement>(null);
    const inputRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      const clipboard = new ClipboardJS(copyButtonRef.value as Element);

      clipboard.on("success", function(e) {
        const buttonCaption = copyButtonRef.value?.innerHTML;
        //Add bgcolor
        inputRef.value?.classList.add("bg-success");
        inputRef.value?.classList.add("text-inverse-success");

        if (copyButtonRef.value) {
          copyButtonRef.value.innerHTML = "Copied!";
        }

        setTimeout(function() {
          if (copyButtonRef.value && buttonCaption) {
            copyButtonRef.value.innerHTML = buttonCaption;
          }

          // Remove bgcolor
          inputRef.value?.classList.remove("bg-success");
          inputRef.value?.classList.remove("text-inverse-success");
        }, 3000); // 3seconds

        e.clearSelection();
      });
    });

    return {
      copyButtonRef,
      inputRef
    };
  },

  compute:{
  },
  data(){
      return { 
          list : [],
          loading: true,
          cifid : 0,
          shareLink : "", 
          sharing: {  
            title: 'Orbix Victus Survey', 
            description: 'Let us know you more by answering this survey!',
            quote: '',
            hashtags: 'digitalprotect;accidentcoverage;familyprotection;',
            twitterUser: 'youyuxi'
          },
          networks: [ 
            //{ network: 'buffer', name: 'Buffer', icon: 'fab fah fa-lg fa-buffer', color: '#323b43' },
            //{ network: 'evernote', name: 'Evernote', icon: 'fab fah fa-lg fa-evernote', color: '#2dbe60' },
            //{ network: 'flipboard', name: 'Flipboard', icon: 'fab fah fa-lg fa-flipboard', color: '#e12828' }, 
            //{ network: 'instapaper', name: 'Instapaper', icon: 'fas fah fa-lg fa-italic', color: '#428bca' },
            //{ network: 'line', name: 'Line', icon: 'fab fah fa-lg fa-line', color: '#00c300' },
            //{ network: 'odnoklassniki', name: 'Odnoklassniki', icon: 'fab fah fa-lg fa-odnoklassniki', color: '#ed812b' },
            //{ network: 'pinterest', name: 'Pinterest', icon: 'fab fah fa-lg fa-pinterest', color: '#bd081c' },
            //{ network: 'pocket', name: 'Pocket', icon: 'fab fah fa-lg fa-get-pocket', color: '#ef4056' },
            //{ network: 'quora', name: 'Quora', icon: 'fab fah fa-lg fa-quora', color: '#a82400' },
            //{ network: 'reddit', name: 'Reddit', icon: 'fab fah fa-lg fa-reddit-alien', color: '#ff4500' },
            //{ network: 'tumblr', name: 'Tumblr', icon: 'fab fah fa-lg fa-tumblr', color: '#35465c' },
            { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope', color: '#333333' },
            { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
            { network: 'linkedin', name: 'LinkedIn', icon: 'fab fah fa-lg fa-linkedin', color: '#007bb5' },
            { network: 'messenger', name: 'Messenger', icon: 'fab fah fa-lg fa-facebook-messenger', color: '#0084ff' },
            { network: 'skype', name: 'Skype', icon: 'fab fah fa-lg fa-skype', color: '#00aff0' },
            { network: 'sms', name: 'SMS', icon: 'far fah fa-lg fa-comment-dots', color: '#333333' }, 
            { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc' },
            { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
            { network: 'viber', name: 'Viber', icon: 'fab fah fa-lg fa-viber', color: '#59267c' },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' } 
          ],
          share_socmed: "",
          showShareDiv: false,
      }
  }, 
  components: {
  },
  props: {
    widgetClasses: String
  }
});
</script>
<style>
#share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
}

a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1;
    font-weight: 500;
}
a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
    text-decoration: none;
    min-height:40px;
    min-width:100px;
    padding: 10px;
}
</style>
